module.exports = __webpack_public_path__ + "static/media/case_circle.8bb189d1.svg";